<template>
  <div
    class="wl-monitor-limit-modal"
    v-if="isModalOpen"
    @click.self="closeModal"
  >
    <tz-modal :open="isModalOpen" @tz-modal-close="closeModal">
      <slot>
        <div class="wl-monitor-limit-modal__content">
          <h2 class="wl-monitor-limit-modal__title">
            Monitored Report Limit Reached
          </h2>
          <p class="wl-monitor-limit-modal__body">
            You’re already monitoring {{ limit }} reports. To monitor a new one,
            remove an existing monitored report first.
          </p>
          <wl-monitor-count-widget />
        </div>
        <div class="wl-monitor-limit-modal__buttons">
          <button @click="closeModal" class="wl-monitor-limit-modal__button">
            Cancel
          </button>
          <button
            @click="openMonitoringPage"
            class="wl-monitor-limit-modal__button wl-monitor-limit-modal__button--primary"
          >
            Manage Monitored Reports
          </button>
        </div>
      </slot>
    </tz-modal>
  </div>
</template>

<script>
import TzModal from '@trazi/tz-modal/src/tz-modal.vue';
import WlMonitorCountWidget from '@/components/wl-monitor-count-widget.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'WlMonitorLimitModal',
  inject: {
    toggleModal: {
      default: () => {}
    }
  },
  components: { TzModal, WlMonitorCountWidget },
  computed: {
    ...mapGetters('report-monitor', ['limit'])
  },
  props: {
    isModalOpen: {
      type: Boolean
    }
  },
  methods: {
    /**
     * Navigate to the report monitoring page
     *
     * @returns {void}
     */
    openMonitoringPage() {
      const { href } = this.$router.resolve({
        name: 'dashboard-monitor'
      });
      window.location.href = href;
    },
    /**
     * Handle closing modal from the cancel button and scrim
     *
     * @returns {void}
     */
    closeModal() {
      this.toggleModal('report-monitoring-limit');
    }
  }
};
</script>
